// extracted by mini-css-extract-plugin
module.exports = {"withGap":"withGap--2XVku","tabbed":"tabbed--Oy20D"};